import { render } from "./StarArticleStatement.vue?vue&type=template&id=6bc1aa3e&scoped=true&ts=true"
import script from "./StarArticleStatement.vue?vue&type=script&lang=ts"
export * from "./StarArticleStatement.vue?vue&type=script&lang=ts"

import "./StarArticleStatement.vue?vue&type=style&index=0&id=6bc1aa3e&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc1aa3e"]])

export default __exports__